import { CustomerResponse, GiftStatus } from "../dto/response/customer";

export type CustomerModel = CustomerResponse;

export interface LearningProgressModel {
  lessonProgressId: number;

  customerId: number;

  courseName: string;

  lessonNumber: number;

  firstActivityDate: number;

  lastActivityDate: number;

  isCompleted: boolean;

  listenTimeMinutes: number;

  sourcePlatform: string;

  subUserNames: string[];
}

export interface InAppPurchaseRecordModel {
  id: number;

  isbn: string;

  productName: string;

  isSubscription: boolean;

  status: string;

  source: string;

  transactionDateTime: number;

  expirationDate: number;

  createdDate: number;

  productId?: number;

  notificationType?: string;

  price?: {
    amount: number;

    currency: string;
  };
}

export interface DailyStreakModel {
  customerId: number;
  subUserId: string;
  userName: string;
  learningCategory: string;
  learningDurationMinutes: number;
  platform: string;
  streakLastUpdated: string;
  timeZone?: string;
}

export interface GiftCardBalanceFieldValue {
  [key: string]: any;
}

export enum CustomerDetailsTab {
  CustomerInfo = "Customer info",
  Transactions = "Transactions",
  Subscriptions = "Subscriptions",
  DailyStreak = "Daily streak",
  LearningProgress = "Learning progress",
  InAppPurchaseRecord = "In-app purchase record",
  Gift = "Gift",
}

export interface GiftCardBalanceCurrencyItem {
  currency: string;
  amount: number;
}

export interface GiftModal {
  givenList: GivenGiftListItem[];
  receivedList: ReceivedGiftListItem[];
}

export interface GivenGiftListItem {
  id: string;
  title: string;
  deliveryDate: string;
  recipient: GiftUserInfo;
  status: GiftStatus;
  redeemedEmail?: string;
}

export interface ReceivedGiftListItem {
  id: string;
  title: string;
  redeemDate?: string;
  subscriptionStartDate?: string;
  subscriptionEndDate?: string;
  giver: GiftUserInfo;
  status: GiftStatus;
  redeemedEmail?: string;
}

export interface GiftUserInfo {
  firstName: string;
  lastName: string;
  email: string;
}

export interface CustomerSubscriberInfo {
  subscriberStatus: "Yes" | "No" | "No Data";
}
